// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerRequest')
class Orders__CustomerRequest {
    @jsonProperty(() => Orders__CustomerRequest.Id)
    id: Orders__CustomerRequest.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "status", "status$id", "messageId", "subject", "sender", "customerDomain", "customerEmail", "requestHtml", "receivedAt", "currency", "currency$id", "customerShippingFees", "vendorRequestHtmls", "vendorSelection", "language", "language$id", "salutationForReply", "evaluationProcessId", "projectNumber", "comment", "items", "attachments", "vendorOffers", "customerOffer", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "status", "status$id", "messageId", "subject", "sender", "customerDomain", "customerEmail", "requestHtml", "receivedAt", "currency", "currency$id", "customerShippingFees", "vendorRequestHtmls", "vendorSelection", "language", "language$id", "salutationForReply", "evaluationProcessId", "projectNumber", "comment", "items", "attachments", "vendorOffers", "customerOffer", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "status", "messageId", "subject", "sender", "customerDomain", "customerEmail", "requestHtml", "receivedAt", "currency", "customerShippingFees", "vendorRequestHtmls", "vendorSelection", "language", "salutationForReply", "evaluationProcessId", "projectNumber", "comment", "items", "attachments", "vendorOffers", "customerOffer", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "status": "Orders.CustomerRequestStatus", "status$id": "string", "messageId": "string", "subject": "string", "sender": "string", "customerDomain": "string", "customerEmail": "string", "requestHtml": "string", "receivedAt": "Date", "currency": "Orders.Currency", "currency$id": "string", "customerShippingFees": "number", "vendorRequestHtmls": "Record<This.VendorLanguage.Id, string>", "vendorSelection": "Record<This.Vendor.Id, Record<This.CustomerRequestItem.Id, boolean>>", "language": "Orders.CustomerLanguage", "language$id": "string", "salutationForReply": "string", "evaluationProcessId": "number", "projectNumber": "string", "comment": "string", "items": "Orders.CustomerRequestItem[]", "attachments": "Orders.CustomerRequestAttachment[]", "vendorOffers": "Orders.VendorOffer[]", "customerOffer": "Orders.CustomerOffer", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze(["status", "currency", "language"] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ items: () => Orders.CustomerRequestItem, attachments: () => Orders.CustomerRequestAttachment, vendorOffers: () => Orders.VendorOffer } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({ customerOffer: () => Orders.CustomerOffer } as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θstatus = Signals.proxySignalDeferred<This.CustomerRequestStatus>(() => (new This.CustomerRequestStatus(This.CustomerRequestStatus.New)) as any);
    private readonly θmessageId = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θsubject = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θsender = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θcustomerDomain = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θcustomerEmail = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrequestHtml = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θreceivedAt = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcurrency = Signals.proxySignalDeferred<This.Currency>(() => (new This.Currency()) as any);
    private readonly θcustomerShippingFees = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θvendorRequestHtmls = Signals.proxySignalDeferred<Record<This.VendorLanguage.Id, string>>(() => ({}) as any);
    private readonly θvendorSelection = Signals.proxySignalDeferred<Record<This.Vendor.Id, Record<This.CustomerRequestItem.Id, boolean>>>(() => (undefined) as any);
    private readonly θlanguage = Signals.proxySignalDeferred<This.CustomerLanguage>(() => (new This.CustomerLanguage()) as any);
    private readonly θsalutationForReply = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θevaluationProcessId = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θprojectNumber = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θcomment = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θitems = Signals.proxySignalDeferred<Orders.CustomerRequestItem[]>(() => (undefined) as any);
    private readonly θattachments = Signals.proxySignalDeferred<Orders.CustomerRequestAttachment[]>(() => (undefined) as any);
    private readonly θvendorOffers = Signals.proxySignalDeferred<Orders.VendorOffer[]>(() => (undefined) as any);
    private readonly θcustomerOffer = Signals.proxySignalDeferred<Orders.CustomerOffer>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerRequest' {
        return 'Orders.CustomerRequest'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerRequest' {
        return 'Orders.CustomerRequest'
    }

    static get __baseType(): 'Orders.CustomerRequest' {
        return 'Orders.CustomerRequest'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerRequest' {
        return 'Orders.CustomerRequest'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerRequest[BoInfoSymbol]
    }

    get status(): This.CustomerRequestStatus {
        return this.θstatus?.()
    }

    set status(status: This.CustomerRequestStatus | This.CustomerRequestStatus.Id) {
        this.θstatus().θupdate(status)
    }

    @jsonProperty(String)
    get 'status$id'(): This.CustomerRequestStatus.Id {
        return this.θstatus?.()?.id
    }

    set 'status$id'(status: string) {
        this.θstatus().θupdate(status as This.CustomerRequestStatus.Id)
    }

    get messageId(): string {
        return this.θmessageId?.()
    }

    set messageId(messageId) {
        this.θmessageId.set(coerceDataType(messageId, 'string', false, true))
    }

    get subject(): string {
        return this.θsubject?.()
    }

    set subject(subject) {
        this.θsubject.set(coerceDataType(subject, 'string', false, true))
    }

    get sender(): string {
        return this.θsender?.()
    }

    set sender(sender) {
        this.θsender.set(coerceDataType(sender, 'string', false, true))
    }

    get customerDomain(): string {
        return this.θcustomerDomain?.()
    }

    set customerDomain(customerDomain) {
        this.θcustomerDomain.set(coerceDataType(customerDomain, 'string', false, true))
    }

    get customerEmail(): string {
        return this.θcustomerEmail?.()
    }

    set customerEmail(customerEmail) {
        this.θcustomerEmail.set(coerceDataType(customerEmail, 'string', false, true))
    }

    get requestHtml(): string {
        return this.θrequestHtml?.()
    }

    set requestHtml(requestHtml) {
        this.θrequestHtml.set(coerceDataType(requestHtml, 'string', false, true))
    }

    get receivedAt(): Date {
        return this.θreceivedAt?.()
    }

    set receivedAt(receivedAt) {
        this.θreceivedAt.set(coerceDataType(receivedAt, 'Date', false, true))
    }

    get currency(): This.Currency {
        return this.θcurrency?.()
    }

    set currency(currency: This.Currency | This.Currency.Id) {
        this.θcurrency().θupdate(currency)
    }

    @jsonProperty(String)
    get 'currency$id'(): This.Currency.Id {
        return this.θcurrency?.()?.id
    }

    set 'currency$id'(currency: string) {
        this.θcurrency().θupdate(currency as This.Currency.Id)
    }

    get customerShippingFees(): number {
        return this.θcustomerShippingFees?.()
    }

    set customerShippingFees(customerShippingFees) {
        this.θcustomerShippingFees.set(coerceDataType(customerShippingFees, 'number', false, true))
    }

    get vendorRequestHtmls(): Record<This.VendorLanguage.Id, string> {
        return this.θvendorRequestHtmls?.()
    }

    set vendorRequestHtmls(vendorRequestHtmls) {
        this.θvendorRequestHtmls.set(coerceDataType(vendorRequestHtmls, 'Record<This.VendorLanguage.Id, string>', false, true))
    }

    get vendorSelection(): Record<This.Vendor.Id, Record<This.CustomerRequestItem.Id, boolean>> {
        return this.θvendorSelection?.()
    }

    set vendorSelection(vendorSelection) {
        this.θvendorSelection.set(coerceDataType(vendorSelection, 'Record<This.Vendor.Id, Record<This.CustomerRequestItem.Id, boolean>>', false, true))
    }

    get language(): This.CustomerLanguage {
        return this.θlanguage?.()
    }

    set language(language: This.CustomerLanguage | This.CustomerLanguage.Id) {
        this.θlanguage().θupdate(language)
    }

    @jsonProperty(String)
    get 'language$id'(): This.CustomerLanguage.Id {
        return this.θlanguage?.()?.id
    }

    set 'language$id'(language: string) {
        this.θlanguage().θupdate(language as This.CustomerLanguage.Id)
    }

    get salutationForReply(): string {
        return this.θsalutationForReply?.()
    }

    set salutationForReply(salutationForReply) {
        this.θsalutationForReply.set(coerceDataType(salutationForReply, 'string', false, true))
    }

    get evaluationProcessId(): number {
        return this.θevaluationProcessId?.()
    }

    set evaluationProcessId(evaluationProcessId) {
        this.θevaluationProcessId.set(coerceDataType(evaluationProcessId, 'number', false, true))
    }

    get projectNumber(): string {
        return this.θprojectNumber?.()
    }

    set projectNumber(projectNumber) {
        this.θprojectNumber.set(coerceDataType(projectNumber, 'string', false, true))
    }

    get comment(): string {
        return this.θcomment?.()
    }

    set comment(comment) {
        this.θcomment.set(coerceDataType(comment, 'string', false, true))
    }

    get items(): Orders.CustomerRequestItem[] {
        return this.θitems?.()
    }

    set items(items) {
        this.θitems.set(coerceDataType(items, Orders.CustomerRequestItem, true, true))
        this.items?.forEach?.(item => { if (item && "request" in item) item.request = this as any })
    }

    get attachments(): Orders.CustomerRequestAttachment[] {
        return this.θattachments?.()
    }

    set attachments(attachments) {
        this.θattachments.set(coerceDataType(attachments, Orders.CustomerRequestAttachment, true, true))
        this.attachments?.forEach?.(item => { if (item && "request" in item) item.request = this as any })
    }

    get vendorOffers(): Orders.VendorOffer[] {
        return this.θvendorOffers?.()
    }

    set vendorOffers(vendorOffers) {
        this.θvendorOffers.set(coerceDataType(vendorOffers, Orders.VendorOffer, true, true))
        this.vendorOffers?.forEach?.(item => { if (item && "request" in item) item.request = this as any })
    }

    get customerOffer(): Orders.CustomerOffer {
        return this.θcustomerOffer?.()
    }

    set customerOffer(customerOffer) {
        this.θcustomerOffer.set(coerceDataType(customerOffer, Orders.CustomerOffer, false, true))
        if (customerOffer) customerOffer.request = this as any
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerRequest>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                items: [],
                attachments: [],
                vendorOffers: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerRequest()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerRequest>, restrictToClass?: Class<Partial<Orders__CustomerRequest>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('status$id', 'messageId', 'subject', 'sender', 'customerDomain', 'customerEmail', 'requestHtml', 'receivedAt', 'currency$id', 'customerShippingFees', 'vendorRequestHtmls', 'vendorSelection', 'language$id', 'salutationForReply', 'evaluationProcessId', 'projectNumber', 'comment', 'items', 'attachments', 'vendorOffers', 'customerOffer', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static async load(id: number, withBinaryData: boolean): Promise<This.CustomerRequest | null> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<This.CustomerRequest | null>('Entity', 'Orders', 'CustomerRequest', undefined, 'load', args)
        return result
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerRequest {
        return equal(this, other)
    }
}

namespace Orders__CustomerRequest { }

export import CustomerRequest = Orders__CustomerRequest
setTimeout(() => {
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'messageId')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'subject')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'sender')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'customerDomain')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'customerEmail')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'requestHtml')
    jsonProperty(() => Date)(Orders__CustomerRequest.prototype, 'receivedAt')
    jsonProperty(() => Number)(Orders__CustomerRequest.prototype, 'customerShippingFees')
    jsonProperty(() => AnyType)(Orders__CustomerRequest.prototype, 'vendorRequestHtmls')
    jsonProperty(() => AnyType)(Orders__CustomerRequest.prototype, 'vendorSelection')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'salutationForReply')
    jsonProperty(() => Number)(Orders__CustomerRequest.prototype, 'evaluationProcessId')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'projectNumber')
    jsonProperty(() => String)(Orders__CustomerRequest.prototype, 'comment')
    jsonArrayProperty(() => Orders.CustomerRequestItem)(Orders__CustomerRequest.prototype, 'items')
    jsonArrayProperty(() => Orders.CustomerRequestAttachment)(Orders__CustomerRequest.prototype, 'attachments')
    jsonArrayProperty(() => Orders.VendorOffer)(Orders__CustomerRequest.prototype, 'vendorOffers')
    jsonProperty(() => Orders.CustomerOffer)(Orders__CustomerRequest.prototype, 'customerOffer')
    jsonProperty(() => Date)(Orders__CustomerRequest.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequest.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerRequest.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequest.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerRequest.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequest.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerRequest.prototype, 'versionNumber')
})

export const CustomerRequestθId = Number;

export type CustomerRequestθId = number;

namespace Orders__CustomerRequest {
    export type Id = NominalType<number, 'Orders.CustomerRequest'>

}
